<template>
  <div class="col-12">
    <b-alert :show="error && error.length ? true : false" variant="danger">
      <div v-if="Array.isArray(error)">
        <div
          class="d-flex flex-column my-1"
          v-for="(error_text, index) in error"
          :key="index"
        >
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <div class="row align-items-center">
      <div class="col-4 col-md-3 p-0">
        <base-select
          class="searchOption bg-transparent mb-0"
          id="change-vehicle-search-input-select"
          :options="searchOptions"
          :value="searchObj.searchOption"
          @change-value="changeSearchOption"
          :useI18n="true"
        >
        </base-select>
      </div>
      <div class="col-8">
        <div class="d-flex">
          <input
            class="form-control search-input-field me-2"
            id="change-vehicle-search-input"
            :type="
              searchObj.searchOption == 'operationalID' ? 'number' : 'text'
            "
            :placeholder="$t('keywords-here')"
            aria-label="Search"
            @keydown.enter="searchForVehicles"
            v-model="searchObj.searchText"
          />
          <div>
            <base-button
              class="primary search-btn mx-1"
              id="change-vehicle-search-btn-search"
              type="submit"
              @click="searchForVehicles"
            >
              {{ $t("search") }}
            </base-button>
          </div>
          <div class="mx-2">
            <base-button
              id="change-vehicle-search-btn-reset"
              variant="secondary"
              @click="reset"
            >
              {{ $t("reset") }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
    <base-spinner v-if="loading" />
    <div v-else class="col-12 mt-4">
      <b-table
        :items="items"
        :fields="fields"
        :hover="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :per-page="0"
        :current-page="currentPage"
        show-empty
        label-sort-asc=""
        label-sort-desc=""
        label-sort-clear=""
        sort-icon-right
        :no-border-collapse="true"
        responsive="lg"
        thead-class="table-thead text-center bg-transparent "
        tbody-class="table-tbody text-center "
        ref="selectableTable"
        info="true"
        class="new-theme-custom-table"
      >
        <template #head(id)="data">
          <span v-if="data">#</span>
        </template>

        <template #cell(id)="{ item }">
          <div class="d-flex align-items-center">
            <div>
              <input
                type="checkbox"
                @change="toggleSelect(item)"
                :checked="selectedVehicleId === item.id"
                :value="item.id"
                :disabled="disableSelect(item.id)"
                class="cursor-pointer mx-3"
              />
            </div>
            <div v-if="item?.operationalID">{{ item.operationalID }}</div>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        aria-controls="my-table"
        class="d-flex justify-content-end"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import TripService from "@/services/trip.service";

export default {
  emits: ["selectVehicle"],
  props: ["trip", "selectedVehicleId", "selectedDriverId"],
  data() {
    return {
      error: null,
      loading: false,
      sortDesc: false,
      perPage: 10,
      currentPage: 1,
      modes: ["single", "range"],
      fields: [
        { key: "id", label: "#", sortable: false, class: "align-middle" },

        {
          key: "brand",
          label: this.$t("brand"),
          sortable: false,
          class: "align-middle",
          thStyle: { backgroundPosition: "right -0.1rem center !important" },
        },
        {
          key: "model",
          label: this.$t("model"),
          sortable: false,
          class: "align-middle",
        },
        {
          key: "makeYear",
          label: this.$t("year-of-making"),
          sortable: false,
          class: "px-1 align-middle",
          thStyle: { backgroundPosition: "right -0.15rem center !important" },
        },
        {
          key: "plateNumber",
          label: this.$t("plate-number"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "category",
          label: this.$t("vehicle-category"),
          sortable: true,
          class: "align-middle",
          thStyle: { minWidth: "80px" },
        },
      ],
      items: [],
      rows: 0,
      sortBy: "",
      searchText: "",
      searchOptions: [
        { value: null, text: "search-for" },
        {
          value: "plateNumber",
          text: "plate-number",
        },
        {
          value: "makeYear",
          text: "make-year",
        },
        {
          value: "operationalID",
          text: "operational-id",
        },
      ],
      searchObj: {
        searchOption: null,
        searchText: "",
      },
    };
  },
  computed: {
    disableSelect() {
      return (id) => {
        return this.selectVehicle && this.selectVehicle !== id;
      };
    },
  },
  watch: {
    currentPage() {
      this.searchForVehicles();
    },
    selectedVehicleId(newVehicleId) {
      // When a new vehicle is selected, disable all other checkboxes
      if (newVehicleId) {
        this.disableAllCheckboxesExcept(newVehicleId);
      } else {
        // If no vehicle is selected, re-enable all checkboxes
        this.enableAllCheckboxes();
      }
    },
  },
  methods: {
    changeSearchOption(option) {
      this.searchObj.searchOption = option;
    },
    disableAllCheckboxesExcept(vehicleId) {
      if (this.items && this.items?.length) {
        this.items.slice().forEach((vehicle) => {
          if (vehicle.vehicleId !== vehicleId) {
            vehicle.disabled = true;
          }
        });
      }
    },
    enableAllCheckboxes() {
      if (this.items && this.items?.length) {
        this.items.slice().forEach((vehicle) => {
          vehicle.disabled = false;
        });
      }
    },
    reset() {
      this.searchObj.searchOption = null;
      this.searchObj.searchText = "";
      this.currentPage = 1;
      this.searchForVehicles();
      this.$emit("selectVehicle", null);
    },
    toggleSelect(item) {
      if (item.id === this.selectedVehicleId) {
        this.$emit("selectVehicle", null);
      } else {
        this.$emit("selectVehicle", item);
      }
    },

    searchForVehicles() {
      this.$emit("selectVehicle", null);
      this.loading = true;

      let params = new URLSearchParams();
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.searchObj && this.searchObj?.searchText) {
        if (this.searchObj.searchOption == "makeYear")
          params.append("makeYear", this.searchObj.searchText);

        if (this.searchObj.searchOption == "plateNumber")
          params.append("plateNumber", "*" + this.searchObj.searchText + "*");

        if (this.searchObj.searchOption == "operationalID")
          params.append("operationalID", Number(this.searchObj.searchText));
      }

      const body = {
        id: this.trip?._id,
      };
      if (this.selectedDriverId) {
        body.driver = this.selectedDriverId;
      }

      TripService.post(body, "available-vehicles", params)
        .then((response) => {
          const data =
            response?.items?.map((each) => {
              return {
                id: each?._id,
                makeYear: each?.makeYear,
                plateNumber: each?.plateNumber,
                category:  this.isLangRtl ?  each?.category?.arabicName : each?.category?.name,
                brand: this.isLangRtl ?  each?.make?.arabicName : each?.make?.name,
                model: this.isLangRtl ?  each?.model?.arabicName : each?.model?.name,
                operationalID: each?.operationalID,
              };
            }) || [];
          this.items = data;
          this.rows = response?.total;
          this.loading = false;
        })
        .catch(({ message }) => {
          this.error = message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.searchForVehicles();
  },
};
</script>

<style lang="scss">
.input-group-text.search-icon {
  background: transparent;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  border-inline-start: unset;
  border-color: var(--color-04);
}
.form-control.search-input {
  border-inline-end: unset;
  border-color: var(--color-04);
}
</style>
